import axios from 'axios';
import Qs from 'qs';
// import Cookies from 'js-cookie';

let instance = axios.create({
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        // 'Content-Type': 'multipart/form-data',
        // 'Content-Type': 'application/json',
    },
});
instance.interceptors.request.use(function(config) {
    if (config.method=="post") {
        Object.assign(config.data, {
            // token: Cookies.get('Token') || '',
            // HeaderKey: Cookies.get('HeaderKey') || localStorage.HeaderKey || ''
        })
    }
    config.data = Qs.stringify(config.data)
    return config;
})

// ========== 响应拦截器 — 防嵌套安全处理 ==========
// instance.interceptors.response.use(
//     function(response) {
//       // 检查响应头中是否包含 X-Frame-Options 或 CSP frame-ancestors
//       const headers = response.headers
//       const hasXFrameOptions = headers['x-frame-options']
//       const hasCspFrameAncestors = headers['content-security-policy'] &&
//         headers['content-security-policy'].includes('frame-ancestors')
   
//       // 如果后端没有设置防嵌套头，在前端做兜底处理
//       if (!hasXFrameOptions && !hasCspFrameAncestors) {
//         // 方式1：通过 meta 标签设置（前端兜底）
//         const meta = document.createElement('meta')
//         meta.httpEquiv = 'Content-Security-Policy'
//         meta.content = "frame-ancestors 'none'"
//         document.head.appendChild(meta)
//       }
   
//       return response
//     },
//     function(error) {
//       return Promise.reject(error)
//     }
//   )
  // ========== 防嵌套处理结束 ==========
export default instance